import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
} from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import ApiList from "../../../../services/apiList";

export const createEval = createAsyncThunk(
  "Journal/journals/createEval",
  async (arg, { getState }) => {
    const slice = getState();
    const journal = slice.JournalApp.journal;
    let config = {
      headers: {
        Authorization: "Bearer " + slice.auth.user.token,
      },
    };

    const body = {
      exam: journal.selectedExam,
      student: journal.examData.Class.course[journal.currentStudentId].id,
      point: journal.currentEval,
    };
    const response = await axios.post(ApiList.examPoint, body, config);
    const data = await response.data.result;
    return data;
  }
);

export const getJournal = createAsyncThunk(
  "Journal/journals/getJournal",
  async (arg, { getState }) => {
    const slice = getState();
    const journal = slice.JournalApp.journal;

    let config = {
      headers: {
        Authorization: "Bearer " + slice.auth.user.token,
      },
    };
    const response = await axios.get(
      ApiList.getJournal + "?id=" + journal.selectedClass?.id,
      config
    );
    const data = await response.data.result;
    return data;
  }
);
export const createFinalPoint = createAsyncThunk(
  "Journal/journals/createFinalPoint",
  async (arg, { getState }) => {
    const slice = getState();
    const journal = slice.JournalApp.journal;
    let config = {
      headers: {
        Authorization: "Bearer " + slice.auth.user.token,
      },
    };

    const body = {
      point: slice.JournalApp.journal.extrapoint,
      student: journal.studentData.course[journal.currentStudentId].id,
      schedule: journal.selectedClass?.id,
    };
    if (slice.JournalApp.journal.selectedId === -1) {
      const response = await axios.post(ApiList.finalPoint, body, config);
      const data = await response.data.result;
      return data;
    } else {
      const response = await axios.put(
        ApiList.finalPoint + slice.JournalApp.journal.selectedId + "/",
        body,
        config
      );
      const data = await response.data.result;
      return data;
    }
  }
);

//ADDITIONAL POINT

export const createAdditionalPoint = createAsyncThunk(
  "Journal/journals/createAdditionalPoint",
  async (arg, { getState }) => {
    const slice = getState();
    const journal = slice.JournalApp.journal;
    let config = {
      headers: {
        Authorization: "Bearer " + slice.auth.user.token,
      },
    };

    const body = {
      point: slice.JournalApp.journal.extrapoint,
      student: journal.studentData.course[journal.currentStudentId].id,
      schedule: journal.selectedClass?.id,
    };
    if (slice.JournalApp.journal.selectedId === -1) {
      const response = await axios.post(ApiList.additionalPoint, body, config);
      const data = await response.data.result;
      return data;
    } else {
      const response = await axios.put(
        ApiList.additionalPoint + slice.JournalApp.journal.selectedId + "/",
        body,
        config
      );
      const data = await response.data.result;
      return data;
    }
  }
);

// ATTENDANCE
export const createAttendance = createAsyncThunk(
  "Journal/journals/createAttendance",
  async (arg, { getState }) => {
    const slice = getState();
    const journal = slice.JournalApp.journal;
    let config = {
      headers: {
        Authorization: "Bearer " + slice.auth.user.token,
      },
    };

    const body = {
      attendanceDate: journal.attendanceDate,
      status: journal.attendanceStatus,
      student: journal.studentData.course[journal.currentStudentId].id,
      schedule: journal.selectedClass?.id,
    };

    if (slice.JournalApp.journal.selectedId === -1) {
      const response = await axios.post(ApiList.attendanceUrl, body, config);
      const data = await response.data.result;
      return data;
    } else {
      const response = await axios.put(
        ApiList.attendanceUrl + slice.JournalApp.journal.selectedId + "/",
        body,
        config
      );
      const data = await response.data.result;
      return data;
    }
  }
);

export const getJournals = createAsyncThunk(
  "Journal/journals/getJournals",
  async (arg, { getState }) => {
    const slice = getState();
    let config = {
      headers: {
        Authorization: "Bearer " + slice.auth.user.token,
      },
    };
    const response = await axios.get(ApiList.teacherData, config);
    const data = await response.data.result;
    return data;
  }
);

export const getExamData = createAsyncThunk(
  "Journal/journals/getExamData",
  async (arg, { getState }) => {
    const slice = getState();
    // const state = journal.journal;
    const state = slice.JournalApp.journal;

    let config = {
      headers: {
        Authorization: "Bearer " + slice.auth.user.token,
      },
    };
    const response = await axios
      .get(ApiList.examResultsUrl + "?id=" + state.selectedClass?.id, config)
      .catch(() => {
        return {
          id: 0,
          schedule: 0,
          day: 0,
          time: 0,
          course: [],
        };
      });
    const data = await response.data.result;

    return data;
  }
);

export const getAttendance = createAsyncThunk(
  "Journal/journals/getAttendance",
  async (arg, { getState }) => {
    const slice = getState();
    const state = slice.JournalApp.journal;

    let config = {
      headers: {
        Authorization: "Bearer " + slice.auth.user.token,
      },
    };
    const response = await axios
      .get(
        ApiList.classStudents +
          "?id=" +
          state.selectedClass?.id +
          "&start_date=" +
          state.teacherData.start +
          "&end_date=" +
          state.teacherData.end,
        config
      )
      .catch(() => {
        return {
          id: 0,
          schedule: 0,
          day: 0,
          time: 0,
          course: [],
        };
      });
    const data = await response.data.result;

    return data;
  }
);

const journalsAdapter = createEntityAdapter({
  selectId: (journal) => journal,
});

const journalsSlice = createSlice({
  name: "Journal/journals",
  initialState: journalsAdapter.getInitialState({
    loading: true,
    tabValue: 0,
    edit: false,
    selectedId: -1,
    extrapoint: 0,
    attendanceDate: "",
    attendanceStatus: 0,
    currentStudentId: 0,
    teacherData: {
      schedule_to_detail: [],
    },
    selectedClass: null,
    studentData: {
      id: 0,
      schedule: 0,
      day: 0,
      time: 0,
      course: [],
    },
    examData: {
      Exams: [],
      Class: {
        course: [],
      },
    },
    journal: { course: [] },
    selectedExam: 0,
    currentEval: 0,
    Exam: {},
  }),
  reducers: {
    setExam: {
      reducer: (state, action) => {
        state.selectedExam = action.payload;
        state.Exam = state.examData.Exams.filter(
          (item) => item.id === action.payload
        )[0];
        state.currentEval = 0;
      },
    },
    setCurrentEval: {
      reducer: (state, action) => {
        let given = state.Exam.point;
        if (action.payload <= given) state.currentEval = action.payload;
        else {
          toast.error(
            <div
              dangerouslySetInnerHTML={{
                __html: "Шалгалтын дүн  " + given + " -с их байж болохгүй",
              }}
            />,
            {
              toastId: "error1",
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: false,
              progress: undefined,
              theme: "colored",
            }
          );
        }
      },
    },
    setCurrentPoint: {
      reducer: (state, action) => {
        state.extrapoint = action.payload;
      },
    },
    setSelectedId: {
      reducer: (state, action) => {
        state.selectedId = action.payload;
      },
    },
    setSelectedClass: {
      reducer: (state, action) => {
        state.selectedClass = action.payload;
      },
    },
    setAttendanceStatus: {
      reducer: (state, action) => {
        state.attendanceStatus = action.payload % 5;
      },
    },
    setAttendanceDate: {
      reducer: (state, action) => {
        state.attendanceDate = action.payload;
      },
    },

    nextStudent: {
      reducer: (state, action) => {
        state.currentStudentId =
          (state.currentStudentId + 1) % state.studentData.course.length;
      },
    },
    selectStudent: {
      reducer: (state, action) => {
        state.currentStudentId = action.payload;
      },
    },
    setEdit: {
      reducer: (state, action) => {
        if (state.selectedClass) state.edit = action.payload;
      },
    },
    setTabValue: {
      reducer: (state, action) => {
        state.tabValue = action.payload;
      },
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getJournals.rejected, (state) => {
        state.loading = false;
        state.teacherData = {
          schedule_to_detail: [],
        };
      })
      .addCase(getJournal.pending, (state) => {
        state.loading = true;
      })
      .addCase(getJournal.fulfilled, (state, action) => {
        state.journal = action.payload;
        state.loading = false;
      })
      .addCase(getJournals.pending, (state) => {
        state.loading = true;
      })
      .addCase(getJournals.fulfilled, (state, action) => {
        state.teacherData = action.payload;
        state.loading = false;
      })
      .addCase(getAttendance.rejected, (state, action) => {
        state.loading = false;
        state.studentData = {
          id: 0,
          schedule: 0,
          day: 0,
          time: 0,
          course: [],
        };
      })
      .addCase(getAttendance.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAttendance.fulfilled, (state, action) => {
        state.studentData = action.payload;
        state.loading = false;
      })
      .addCase(getExamData.rejected, (state, action) => {
        state.loading = true;
        state.examData = {
          Exams: [],
          Class: null,
        };
      })
      .addCase(getExamData.pending, (state) => {
        state.loading = true;
      })
      .addCase(getExamData.fulfilled, (state, action) => {
        state.examData.Exams = action.payload.Exams;
        state.examData.Class = action.payload.class[0];
        state.loading = false;
      });
  },
});

export const {
  setJournalFilter,
  setSelectedClass,
  nextStudent,
  setEdit,
  setTabValue,
  selectStudent,
  setCurrentEval,
  setAttendanceDate,
  setAttendanceStatus,
  setCurrentPoint,
  setSelectedId,
  setExam,
} = journalsSlice.actions;

export default journalsSlice.reducer;
